export const BLACK = '#212B36';
export const WHITE = '#FFFFFF';
export const XOS_RED = '#FE0300';
export const NEUTRAL_GREY = '#F5F5F5';
export const GREY = '#C4CDD5';
export const MEDIUM_GREY = '#777777';
export const DARK_GREY = '#343A40';
export const GREEN = '#32CD32';
export const BLUE = '#79A9D1';
